// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"GifLoader_loader_container__bAa3a","loader":"GifLoader_loader__dLGmO","loading":"GifLoader_loading__S8S55","spin":"GifLoader_spin__aqlBE"};